import aos from "aos";
// import createStore from "./common/createStore.js";
import { equalHeight } from "./common/equalHeight.js";
import { truncateText } from "./common/truncateText.js";
import {
  adjustSlideLeftPadding,
  resetSlideLeftPadding,
} from "./common/carouselSlidePadding";
import initContainers from "./components/Container/initContainers.js";
import initDesktopHeader from "./components/GlobalHeader/initDesktopHeader.js";
import initGlobalBackgroundArrows from "./components/GlobalBackgroundArrows/initGlobalBackgroundArrows.js";
import initPageHeader from "./components/PageHeader/initPageHeader.js";
import initHero from "./components/Hero/initHero.js";
import initMobileHeader from "./components/GlobalHeader/initMobileHeader.js";
import initQuickLinks from "./components/QuickLinks/initQuickLinks.js";
import initSearch from "./components/Search/initSearch.js";
import initTabs from "./components/Tabs/initTabs.js";
import initAdmissionsTabs from "./components/AdmissionsTabs/initAdmissionsTabs.js";
import initYouTubeApi from "./common/youtubeApi.js";
import initAccordion from "./components/Accordion/initAccordion.js";
import initAdditionalInsights from "./components/AdditionalInsights/initAdditionalInsights.js";
import initSimpleFilter from "./components/SimpleFilter/initSimpleFilter.js";
import applicationTilesEqualHeight from "./components/ApplicationTiles/applicationTilesEqualHeight.js";
import applicationTilesStickyHeaders from "./components/ApplicationTiles/applicationTilesStickyHeaders.js";
import swapPlayerLocation from "./components/VideoPromo/swapPlayerLocation.js";
import initTooltips from "./components/ExecEdProgramDetail/initTooltips.js";
import initMeter from "./components/Meter/initMeter.js";
import initAccordionPromo from "./components/AccordionPromo/initAccordionPromo.js";

import renderBackToTop from "./components/BackToTop/renderBackToTop.jsx";
import renderDynamicContentListing from "./components/DynamicContentListing/renderDynamicContentListing.jsx";
import renderDynamicEventsListing from "./components/DynamicEventsListing/renderDynamicEventsListing.jsx";
import renderFeaturedPeople from "./components/FeaturedPeople/renderFeaturedPeople.jsx";
import renderMultiPromo from "./components/MultiPromo/renderMultiPromo.jsx";
import renderPeopleListing from "./components/PeopleListing/renderPeopleListing.jsx";
import renderQuickSearchBar from "./components/QuickSearchBar/renderQuickSearchBar.jsx";
import renderSecondaryNavigation from "./components/SecondaryNavigation/renderSecondaryNavigation.jsx";
import renderSlideShowCarousel from "./components/SlideShowCarousel/renderSlideShowCarousel.jsx";
import renderTestimonialsCarousel from "./components/Testimonials/renderTestimonialsCarousel.jsx";
import scrollRelatedContent from "./components/RelatedContent/scrollRelatedContent.js";
import {
  renderManualEventsListingUpcoming,
  renderManualEventsListingPast,
} from "./components/ManualEventsListing/renderManualEventsListing.jsx";
import renderBioListing from "./components/BioListing/renderBioListing.jsx";
import renderAcademicAndResearchListing from "./components/AcademicAndResearchListing/renderAcademicAndResearchListing.jsx";
import renderFacultyDirectoryListing from "./components/FacultyDirectoryListing/renderFacultyDirectoryListing.jsx";
import renderExecEdFeaturedPrograms from "./components/ExecEdFeaturedPrograms/renderExecEdFeaturedPrograms.jsx";
import renderExecEdRelatedPrograms from "./components/ExecEdRelatedPrograms/renderExecEdFeaturedPrograms.jsx";
import renderExecEdProgramListing from "./components/ExecEdProgramListing/renderExecEdProgramListing.jsx";
import renderExecEdCalendly from "./components/ExecEdCalendly/renderExecEdCalendly.jsx";
import renderJumpNavigation from "./components/ExecEdJumpNavigation/renderJumpNavigation.jsx";
import renderMultimediaGallery from "./components/MultimediaGallery/renderMultimediaGallery.jsx";

import initExecEdDesktopHeader from "./components/ExecEdGlobalHeader/initExecEdDesktopHeader.js";
import initExecEdMobileHeader from "./components/ExecEdGlobalHeader/initExecEdMobileHeader.js";

document.addEventListener("DOMContentLoaded", () => {
  //google programmable search
  initSearch();

  //aos animations
  aos.init();

  // Video APIs
  initYouTubeApi();

  //vanilla js components
  initMobileHeader();
  initDesktopHeader();
  initPageHeader();
  initHero();
  initContainers();
  initTabs();
  initAdmissionsTabs();
  initQuickLinks();
  initAccordion();
  initAdditionalInsights();
  initSimpleFilter();
  initExecEdDesktopHeader();
  initExecEdMobileHeader();
  initTooltips();
  initAccordionPromo();

  //react components
  renderQuickSearchBar();
  renderMultiPromo();
  renderTestimonialsCarousel();
  renderDynamicContentListing();
  renderDynamicEventsListing();
  renderSlideShowCarousel();
  renderPeopleListing();
  renderBackToTop();
  renderSecondaryNavigation();
  renderJumpNavigation();
  renderFeaturedPeople();
  renderManualEventsListingUpcoming();
  renderManualEventsListingPast();
  renderBioListing();
  renderAcademicAndResearchListing();
  renderFacultyDirectoryListing();
  renderMultimediaGallery();
  renderExecEdFeaturedPrograms();
  renderExecEdRelatedPrograms();
  renderExecEdProgramListing();
  renderExecEdCalendly();

  scrollRelatedContent();

  // Truncate text via class
  if (document.getElementsByClassName("js-truncate-text").length) {
    const itemsToTruncate = document.getElementsByClassName("js-truncate-text");
    [...itemsToTruncate].forEach((item) => {
      const text = item.textContent;
      const textLength = item.dataset.charLimit ? item.dataset.charLimit : null;
      if (textLength) {
        item.textContent = truncateText(text, textLength);
      } else {
        item.textContent = truncateText(text);
      }
    });
  }
});

const matchesNavigation = window.matchMedia("(min-width: 1200px)").matches;
const matchesLarge = window.matchMedia("(min-width: 1024px)").matches;
const matchesMedium = window.matchMedia("(min-width: 746px)").matches;

window.addEventListener("load", () => {
  if (document.querySelector(".--show-background-arrows")) {
    initGlobalBackgroundArrows();
  }

  initMeter();

  // Init video players
  // Note: YouTube videos are handled in a separate file, youtubeApi.js
  let panoptoPlayers = Array.from(
    document.getElementsByClassName("js-panopto-player"),
  );
  let wistiaPlayers = Array.from(
    document.getElementsByClassName("js-wistia-player"),
  );
  let vimeoPlayers = Array.from(
    document.getElementsByClassName("js-vimeo-player"),
  );

  panoptoPlayers ? playVideo(panoptoPlayers) : null;
  wistiaPlayers ? playVideo(wistiaPlayers) : null;
  vimeoPlayers ? playVideo(vimeoPlayers) : null;

  function embedVideo(player, wrapper, url) {
    player.classList.add("video-api-player--has-started");

    // Commented out code below is to include Wistia script, which adds
    // JSON-LD schema to the DOM automatically. May be used in the future.

    // First, need to extract the video ID from the url.
    // Example of how URL needs to be formatted:
    // https://fast.wistia.net/embed/iframe/5iovmmonyw?&autoPlay=true
    // const wistiaVideoId = url.split("/").pop().split("?")[0];

    // Create and append Wistia script
    // const script = document.createElement("script");
    // script.src = "//fast.wistia.com/assets/external/E-v1.js";
    // script.async = true;
    // document.head.appendChild(script);

    // (wrapper.innerHTML = `<iframe src="//fast.wistia.net/embed/iframe/${wistiaVideoId}" allowtransparency="true" frameborder="0" class="wistia_embed" name="wistia_embed" allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen></iframe>`),
    //   (window._wq = window._wq || []);
    // _wq.push({
    //   id: wistiaVideoId,
    //   onReady: function (video) {},
    // });

    // Create iframe embed for all players except Wistia
    if (!player.classList.contains("js-wistia-player")) {
      wrapper.innerHTML = `<iframe src="${url}" width="100%" height="auto" allow="autoplay; fullscreen"></iframe>`;
    } else {
      // Create a special popover embed for Wistia videos
      wrapper.innerHTML = `<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><span class="wistia_embed wistia_async_${url} popover=true videoFoam=true" style="display:inline-block;height:100%;position:relative;width:100%">&nbsp;</span></div></div>`;
    }
  }

  function playVideo(playerArr) {
    playerArr.forEach((player, i) => {
      const playBtn = player.querySelector(".js-video-api-play");
      const wrapper = player.querySelector(".js-video-wrapper");
      const url = player.getAttribute("data-id");

      // If the custom play button (and therefore a placeholder image) exists,
      // set up the click handler
      if (playBtn !== null || undefined) {
        playBtn.addEventListener("click", function () {
          embedVideo(player, wrapper, url);
        });
        // Otherwise, just embed the video right on the page
      } else {
        embedVideo(player, wrapper, url);
      }
    });
  }

  // Make video promos equal height (needed for mobile view carousel)
  if (document.getElementsByClassName("js-multi-promo-video").length) {
    !matchesLarge && equalHeight(".js-multi-promo-video-slide");

    window.addEventListener("resize", () => {
      equalHeight(".js-multi-promo-video-slide");
    });
  }

  // TBD if we're using this solution instead of CSS
  // if (document.getElementsByClassName("video-promo").length) {
  //   swapPlayerLocation();
  // };

  const secondaryNav = document.querySelector(".js-secondary-navigation-mount");
  if (secondaryNav) {
    let nextSibling = secondaryNav.nextElementSibling.classList;

    // Add or remove a bottom margin class to the secondary nav
    // depending on whether there is a jump nav or mini page header present
    if (
      nextSibling.contains("js-jump-navigation-mount") ||
      nextSibling.contains("page-header__mini--exec-ed")
    ) {
      secondaryNav.classList.add("no-bottom-margin");
    } else {
      secondaryNav.classList.remove("no-bottom-margin");
    }

    // Add or remove a top margin class to the secondary nav
    // depending on whether there is a page banner/header component present
    if (
      document.getElementsByClassName("page-banner").length ||
      document.getElementsByClassName("page-header__image-wrapper").length ||
      document.getElementsByClassName("page-header__video-wrapper").length ||
      document.getElementsByClassName("page-header--exec-ed").length
    ) {
      secondaryNav.classList.add("--with-page-banner");
    } else {
      secondaryNav.classList.remove("--with-page-banner");
    }
  }

  // Exec ed header intersection observer
  // Used to show and hide a correspnding "mini" page header
  // when scrolled down and up the page, respectively
  const pageHeader = document.querySelector(".js-page-header--exec-ed");
  const miniPageHeader = document.querySelector(
    ".js-page-header__mini--exec-ed",
  );

  // Builds an array ranging from 0 to 1 by a given amount of steps.
  // (These become the intersection threshold points as we scroll on the page)
  const thresholdArray = (steps) =>
    Array(steps + 1)
      .fill(0)
      .map((_, index) => index / steps || 0);

  let previousY = 0;

  function handleIntersection(entries) {
    entries.map((entry) => {
      const currentY = entry.boundingClientRect.y;
      const currentRatio = entry.intersectionRatio;
      const isIntersecting = entry.isIntersecting;

      // Scrolling down/up
      if (currentY < previousY) {
        // Will fire when page header is off-screen
        if (currentRatio <= 0.4) {
          miniPageHeader.classList.add("is-visible");
        }
      } else if (currentY > previousY && isIntersecting) {
        // Will fire when page header is mostly visible on screen
        if (currentRatio >= 0.9) {
          miniPageHeader.classList.remove("is-visible");
        }
      }

      previousY = currentY;
    });
  }

  const observer = new IntersectionObserver(handleIntersection, {
    threshold: thresholdArray(20),
  });

  if (pageHeader) {
    observer.observe(pageHeader);
  }

  // Program Detail - scroll smoothly into view
  // (needed when clicking a CTA button in the mini page header, which
  // scrolls to the program detail anchor on a page)
  if (document.querySelector(".js-page-header__mini-cta")) {
    document
      .querySelector(".js-page-header__mini-cta")
      .addEventListener("click", function (e) {
        e.preventDefault();

        if (document.querySelector("#program-details")) {
          document
            .querySelector("#program-details")
            .scrollIntoView({ behavior: "smooth" });
        }
      });
  }

  // Faculty Bio - hide accordion button if its panel is empty,
  // or has a table with 0 results
  // Example: Panel contains an Academic and Research Listing table that
  // returns no results
  if (document.getElementsByClassName("faculty-bio__accordion").length) {
    const accordionButtons = Array.from(
      document.querySelectorAll(".faculty-bio__accordion .accordion__item"),
    );

    accordionButtons.forEach((button, i) => {
      // Get associated panel
      let panel = button.querySelector(".accordion__panel");

      // Check if panel contains no content
      let isEmpty = panel.innerHTML === "";

      // Check if panel contains an Academic and Research Listing table,
      // then check if the table has results.
      let hasTable = panel.getElementsByClassName(
        "js-academic-research-listing-mount",
      ).length;
      let tableHasNoResults;
      if (hasTable) {
        let table = panel.getElementsByClassName(
          "js-academic-research-listing-mount",
        )[0];

        tableHasNoResults = table.querySelector(
          ".academic-research-listing__no-results",
        );
      }

      if (isEmpty || tableHasNoResults) {
        button.remove();
      }
    });
  }

  // Set each dropdown facet menu to be at least the width of their parent button
  if (
    matchesNavigation &&
    document.getElementsByClassName("js-facets__menu").length
  ) {
    const dropdownMenus = Array.from(
      document.querySelectorAll(".js-facets__menu"),
    );

    dropdownMenus.forEach((menu, i) => {
      let menuWidth = menu.offsetWidth;
      let button = menu.previousSibling;
      let buttonWidth = button.offsetWidth;

      menuWidth < buttonWidth ? (menu.style.width = buttonWidth + "px") : null;
    });
  }

  if (
    matchesMedium &&
    document.getElementsByClassName("application-tiles__tile-wrapper").length
  ) {
    applicationTilesEqualHeight();
  }

  if (
    document.getElementsByClassName("application-tiles__tile-wrapper").length
  ) {
    applicationTilesStickyHeaders();
  }

  // Bio listing descriptions
  if (document.getElementsByClassName("bio-listing__description").length) {
    matchesMedium && equalHeight(".bio-listing__description");
    window.addEventListener("resize", () => {
      equalHeight(".bio-listing__description");
    });
  }

  // Layout Grid headers
  if (
    matchesMedium &&
    document.getElementsByClassName("layout-grid__grid").length
  ) {
    const layoutGrids = Array.from(
      document.getElementsByClassName("layout-grid__grid"),
    );

    layoutGrids.forEach((grid) => {
      const gridHeaders = Array.from(
        grid.getElementsByClassName("layout-grid__column-header"),
      );
      const headerHeights = [];

      gridHeaders.forEach((header) => {
        header.style.height = "auto";
        headerHeights.push(header.clientHeight);
      });

      gridHeaders.forEach((header) => {
        header.style.height = Math.max.apply(Math, headerHeights) + "px";
      });
    });
  }

  // Handle testimonials quote heights in mobile view
  // NOTE: This version is for if we want to implement equal quote heights on mobile ONLY.
  // if (
  //   document.getElementsByClassName("testimonials-quote__text-wrapper").length
  // ) {
  //   matchesMaxMedium ? equalHeight(".testimonials-quote__text-wrapper") : null;
  //   window.addEventListener("resize", () => {
  //     let isMobile = window.matchMedia("(max-width: 745px)").matches;
  //     const wrappers = Array.from(
  //       document.getElementsByClassName("testimonials-quote__text-wrapper"),
  //     );

  //     isMobile
  //       ? equalHeight(".testimonials-quote__text-wrapper")
  //       : wrappers.forEach((wrapper, i) => {
  //           wrapper.style.height = "";
  //         });
  //   });
  // }

  // Handle testimonials quote heights
  if (
    // matchesMaxMedium &&
    document.getElementsByClassName("testimonials-quote__text-wrapper").length
  ) {
    equalHeight(".testimonials-quote__text-wrapper");
    window.addEventListener("resize", () => {
      equalHeight(".testimonials-quote__text-wrapper");
    });
  }

  // Handle exec ed programs card heights on mobile carousel
  if (
    !matchesLarge &&
    document.getElementsByClassName("js-card-equal-heights").length
  ) {
    equalHeight(".js-card-equal-heights");
    window.addEventListener("resize", () => {
      equalHeight(".js-card-equal-heights");
    });
  }

  // Handle when there is a single card in desktop view;
  // need to add a class to handle some special CSS
  if (document.getElementsByClassName("program-card").length === 1) {
    if (matchesLarge) {
      document
        .getElementsByClassName("program-card")[0]
        .classList.add("program-card--single");
    }

    window.addEventListener("resize", () => {
      if (matchesLarge) {
        document
          .getElementsByClassName("program-card")[0]
          .classList.add("program-card--single");
      }
    });
  }

  //statistics animation descriptions
  matchesMedium && equalHeight(".statistic-animation__description");

  //Handle VariantType = 2 for Slideshow
  if (document.getElementsByClassName("slide-show-carousel").length) {
    const carouselElements = Array.from(
      document.querySelectorAll(".slide-show-carousel"),
    );

    carouselElements.forEach((el) => {
      if (el.dataset.variant === "2" && window.innerWidth >= 1200) {
        adjustSlideLeftPadding(el);
      }
    });

    let updatePadding = false;
    window.addEventListener("resize", () => {
      carouselElements.forEach((el) => {
        if (el.dataset.variant === "2" && window.innerWidth >= 1200) {
          adjustSlideLeftPadding(el);
          updatePadding = true;
        } else if (updatePadding) {
          resetSlideLeftPadding(el);
          updatePadding = false;
        }
      });
    });
  }
});

//statistics animation descriptions
if (
  document.getElementsByClassName("statistic-animation__description").length
) {
  window.addEventListener("resize", () => {
    equalHeight(".statistic-animation__description");
  });
}
